import encryption from "../crypto/encryptionService";
import sessionStorage from "../common/sessionStorageService";
import localStorage from "../common/localStorageService";

const accessTokenKey = "SHAREDO_ACCESS_TOKEN";
const refreshTokenKey = "SHAREDO_REFRESH_TOKEN";
const verifierTokenKey = "SHAREDO_VERIFIER_TOKEN"

const getAccessToken = () => sessionStorage.get(accessTokenKey);

const setAccessToken = token => sessionStorage.set(accessTokenKey, token);

const getRefreshToken = () => {
    const encryptedToken = localStorage.get(refreshTokenKey);
    if (encryptedToken) {
        return encryption.decrypt(encryptedToken);
    }

    return null;
};

const setRefreshToken = token => {
    const encryptedToken = encryption.encrypt(token);
    localStorage.set(refreshTokenKey, encryptedToken);
}

const getVerifierToken = () => {
    return sessionStorage.get(verifierTokenKey);
}

const setVerifierToken = verifier => sessionStorage.set(verifierTokenKey, verifier);

const clear = () => {
    sessionStorage.remove(accessTokenKey);
    sessionStorage.remove(verifierTokenKey);
    localStorage.remove(refreshTokenKey);
}

export default {
    getAccessToken,
    setAccessToken,
    getRefreshToken,
    setRefreshToken,
    getVerifierToken,
    setVerifierToken,
    clear,
};